import {GoogleAnalyticsService} from 'modules/google-analytics/service';

export function sendGtagEvent(eventData: Record<string, any>) {
    GoogleAnalyticsService.gtag(eventData);
}
